import * as React from 'react'
import { Checkmark, Container, Input } from './Checkbox.styles'

interface IProps {
  label?: React.ReactNode
  checked: boolean
  disabled: boolean
  invalid: boolean
  onChange: (checked: boolean) => void
}

export default class Checkbox extends React.Component<IProps> {
  public static defaultProps = {
    disabled: false,
    invalid: false,
  }

  public render() {
    const { checked, disabled, invalid, label } = this.props

    return (
      <Container
        disabled={disabled}
        onClick={(event: { stopPropagation: () => void }) => event.stopPropagation()}
      >
        <Input type="checkbox" checked={checked} disabled={disabled} onChange={this.handleChange} />
        <Checkmark checked={checked} disabled={disabled} invalid={invalid} />
        {label}
      </Container>
    )
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation()
    this.props.onChange(event.target.checked)
  }
}
